import './icon.scss';

import classNames from 'classnames';

export enum IconType {
  Access = 'Access',
  Add = 'Add',
  AddPhoto = 'AddPhoto',
  AddToCart = 'AddToCart',
  AddUser = 'AddUser',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  ArrowUp = 'ArrowUp',
  Available = 'Available',
  Belgium = 'Belgium',
  BigArrowRight = 'BigArrowRight',
  Calculate = 'Calculate',
  Calendar = 'Calendar',
  Call = 'Call',
  CategoryFinder = 'CategoryFinder',
  CheckMinus = 'CheckMinus',
  Claims = 'Claims',
  Close = 'Close',
  Co2 = 'Co2',
  ColorBrightness = 'ColorBrightness',
  ColorSaturation = 'ColorSaturation',
  ColorTemp = 'ColorTemp',
  CompareArrows = 'CompareArrows',
  Copy = 'Copy',
  Delete = 'Delete',
  Deselect = 'Deselect',
  DoubleArrowLeft = 'DoubleArrowLeft',
  DoubleArrowRight = 'DoubleArrowRight',
  Download = 'Download',
  DragHandle = 'DragHandle',
  Edit = 'Edit',
  Empty = 'Empty',
  Error = 'Error',
  Facebook = 'Facebook',
  Favorites = 'Favorites',
  FavoritesAdded = 'FavoritesAdded',
  File = 'File',
  FiletypeCsv = 'FiletypeCsv',
  FiletypeDoc = 'FiletypeDoc',
  FiletypeDocx = 'FiletypeDocx',
  FiletypeDwg = 'FiletypeDwg',
  FiletypeFile = 'FiletypeFile',
  FiletypePdf = 'FiletypePdf',
  FiletypeTxt = 'FiletypeTxt',
  FiletypeXml = 'FiletypeXml',
  FiletypeXsl = 'FiletypeXsl',
  FiletypeZip = 'FiletypeZip',
  Filters = 'Filters',
  Folder = 'Folder',
  Germany = 'Germany',
  GridView = 'GridView',
  Hamburger = 'Hamburger',
  Hand = 'Hand',
  Home = 'Home',
  Inbox = 'Inbox',
  Info = 'Info',
  Instagram = 'Instagram',
  Installer = 'Installer',
  Invoices = 'Invoices',
  Italy = 'Italy',
  Link = 'Link',
  Linkedin = 'Linkedin',
  ListView = 'ListView',
  Location = 'Location',
  Lock = 'Lock',
  Locked = 'Locked',
  Logout = 'Logout',
  Mail = 'Mail',
  Mobile = 'Mobile',
  More = 'More',
  New = 'New',
  OpenNewScreen = 'OpenNewScreen',
  Pause = 'Pause',
  Pin = 'Pin',
  Pinterest = 'Pinterest',
  Play = 'Play',
  Print = 'Print',
  Projects = 'Projects',
  PushPinFilled = 'PushPinFilled',
  Referral = 'Referral',
  Restart = 'Restart',
  Samples = 'Samples',
  Save = 'Save',
  Schedule = 'Schedule',
  Search = 'Search',
  Settings = 'Settings',
  Share = 'Share',
  ShoppingCartAdd = 'ShoppingCartAdd',
  Show = 'Show',
  ShowOff = 'ShowOff',
  Sort = 'Sort',
  Support = 'Support',
  Sustainability = 'Sustainability',
  Synced = 'Synced',
  SyncedOff = 'SyncedOff',
  TableView = 'TableView',
  Twitter = 'Twitter',
  Ukraine = 'Ukraine',
  Unlocked = 'Unlocked',
  Upload = 'Upload',
  User = 'User',
  Users = 'Users',
  Warning = 'Warning',
  Whatsapp = 'Whatsapp',
  Youtube = 'Youtube',
  ErrorQuestion = 'ErrorQuestion',
  AiChat = 'AiChat',
}

export interface IconProps {
  iconType: IconType;
  className?: string;
  rotate?: boolean;
}

const Icon = ({ iconType, className, rotate }: IconProps) => {
  // IMPORTANT: Avoid using window-dependent logic so that the server and client
  // render the same xlinkHref value (prevents hydration attribute mismatch warnings).
  // Using a root-relative path keeps it stable across SSR and CSR.
  const href = `/assets/svg/symbols.svg#${iconType}`;

  return (
    <svg className={classNames(className, { rotate })} aria-hidden="true">
      <use xlinkHref={href} />
    </svg>
  );
};

export default Icon;
